import utils from 'Utils';

const { mapKV } = utils.obj;

/**
 * Check to see if indicators are selected but categories are not (setting them if needed)
 * @param  {Object} router          router state
 * @param  {Object} [data={}]       default global state
 * @param  {Object} [verify={} }]   verficiation state
 * @return {Object}                 state object
 */
export default function setSelectedCategories(state) {
  const { categories, indicators } = state.data;
  const { indicators: activeIndicators = false } = state.router;
  const { selectedCategories = [] } = state.data;

  if (!!activeIndicators && 0 === selectedCategories.length) {
    const megaIndicators = mapKV(
      indicators,
      (val, key) => ({ ...val, key }),
      true
    ).reduce((acc, item) => (Array.isArray(item.children) ?
      acc.concat(item) : acc), []);

    const keys = (
      Array.isArray(activeIndicators) ? activeIndicators : [activeIndicators]
    ).reduce((acc, key) => {
      const megaKey = megaIndicators
        .filter(({ children }) => -1 < children.indexOf(parseInt(key, 10)))
        .shift();
      if (megaKey && -1 === acc.indexOf(megaKey.key)) {
        return acc.concat(megaKey.key, key);
      }
      return acc.concat(key);
    }, []);

    const selected = Object.keys(categories).filter((key) =>
      categories[key].indicators.some(
        (indicator) => -1 < keys.indexOf(`${indicator}`)
      )
    ).map((key) => parseInt(key, 10));

    return { ...state, data: { ...state.data, selectedCategories: selected } };
  }

  return { ...state };
}



// WEBPACK FOOTER //
// ./app/services/verification/setSelectedCategories.js